export const baseURL = "https://greedylion.queenlive.fun/";
export const adminBaseURL = "https://admin.queenlive.fun/";
export const key = "BS67Rfb0Tf";
